import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import loadable from '@loadable/component';
import classNames from 'classnames';

import { ClickElement, trackProductDetailButtonClick } from '@jsmdg/tracking';
import { ClubIcon, InfoIcon, PureButton } from '@jsmdg/yoshi';
import styles from './ClubDiscountBadge.module.scss';

const LoadableClubDiscountModal = loadable(
    async () => import('./ClubDiscountModal/ClubDiscountModal'),
);

const messages = defineMessages({
    badgeIconA11yText: {
        defaultMessage: 'Informationen zum Club-Deal',
    },
    badgeText: {
        defaultMessage: '-15% für eingeloggte Kunden',
    },
});

type ClubDiscountBadgeProps = {
    readonly className?: string;
};

const ClubDiscountBadge = ({ className }: ClubDiscountBadgeProps): JSX.Element => {
    const intl = useIntl();
    const [showModal, setShowModal] = useState(false);
    const badgeText = intl.formatMessage(messages.badgeText);

    const openModal = (): void => {
        setShowModal(true);

        trackProductDetailButtonClick(ClickElement.CustomerAccountInformationPopup, badgeText);
    };

    const closeModal = (): void => {
        setShowModal(false);
    };

    return (
        <>
            <LoadableClubDiscountModal onRequestClose={closeModal} showModal={showModal} />
            <PureButton
                aria-label={intl.formatMessage(messages.badgeIconA11yText)}
                className={classNames('d-flex ', className, styles.badgeContainer)}
                onClick={openModal}
            >
                <div
                    className={classNames(
                        'd-flex align-items-center px-1x py-0-5x',
                        styles.badgeTextContainer,
                    )}
                >
                    <ClubIcon className={classNames(styles.clubIcon, 'mr-0-5x')} size={24} />
                    <div className={classNames('font-complementary mr-0-5x', styles.badgeText)}>
                        {badgeText}
                    </div>
                    <InfoIcon size={24} />
                </div>
            </PureButton>
        </>
    );
};

export { ClubDiscountBadge };
